import React from 'react';
import FBKeywordSlideoutBannerNormalSrc from './FBKeywordSlideoutBanner_normal.png';
import FBKeywordSlideoutBannerWhiteSrc from './FBKeywordSlideoutBanner_white.png';

export const FBKeywordSlideoutBanner = ({
  textColor,
}: {
  textColor: 'white' | 'normal';
}) => {
  return textColor === 'white' ? (
    <img src={FBKeywordSlideoutBannerWhiteSrc} />
  ) : (
    <img src={FBKeywordSlideoutBannerNormalSrc} />
  );
};
